import { useCallback } from 'react';

import { useUserProfile } from 'contexts/UserProfileContext';
import type { NoopT } from 'declarations/types/common';

type UseColumnPickerSettingsPopupT = {
  isPopupOpened: boolean;
  handleCloseColumnPickerPopup: (onClosePopupCb: NoopT | undefined) => NoopT;
};

const useColumnPickerSettingsPopup = (): UseColumnPickerSettingsPopupT => {
  const { isColumnPickerPopupOpened, setColumnPickerPopupVisibility } = useUserProfile();

  const handleCloseColumnPickerPopup = useCallback(
    (onClosePopupCb: NoopT | undefined) => () => {
      onClosePopupCb ? onClosePopupCb() : setColumnPickerPopupVisibility(false);
    },
    [setColumnPickerPopupVisibility]
  );

  return {
    handleCloseColumnPickerPopup,
    isPopupOpened: isColumnPickerPopupOpened,
  };
};

export default useColumnPickerSettingsPopup;
